import useCollection from "areas/collection/hoc/use-collection"

import DescriptionAccordion from "./description-accordion"
import FAQ from "./faq"

const CollectionDescription = () => {
  const {
    data: { description, description_type: descriptionType, faqs } = {},
  } = useCollection()

  if (!description && !faqs?.length) return null

  return (
    <div className="bg-subpolar text-neutral py-24">
      <div className="contained px-16">
        {description && (
          <>
            {["markdown", "spreadsheet"].includes(descriptionType) ? (
              <DescriptionAccordion>{description}</DescriptionAccordion>
            ) : (
              <div dangerouslySetInnerHTML={{ __html: description }} />
            )}
          </>
        )}
        {faqs?.length > 0 && <FAQ faqs={faqs} />}
      </div>
    </div>
  )
}

export default CollectionDescription
